export const AppConstants = {

  ALERTTYPE_STANDARD: "Standard",
  ALERTTYPE_COUNTER: "Counter",
  ALERTTYPE_EXTRACTOR: "Extractor"

};

